import React, { Component } from 'react';
import ReactDOMServer from "react-dom/server";

export default class IframePrint extends Component {

    iframe_ref = null;

    writeHTML = (frame) => {

        if (!frame) {
            return;
        }

        this.iframe_ref = frame;
        const html = ReactDOMServer.renderToStaticMarkup(this.props.reactElement);

        let doc = frame.contentDocument;
        doc.open();
        doc.write(html.toString());
        doc.close();

        frame.style.width = '0';
    }

    render() {
        return (
            <iframe id={this.props.id} name={this.props.id} src='about:blank' scrolling='no' frameBorder='0' ref={this.writeHTML}></iframe>
        )
    }
}